// RECORD API
import Request from '../base'
export default {
  save (options) {
    return Request.post('/ebermain/mainapi/record/record/save', options)
  },
  delete (options) {
    return Request.post('/ebermain/mainapi/record/record/delete', options)
  },
  load (options) {
    return Request.post('/ebermain/mainapi/record/record/load', options)
  },
  list (options) {
    return Request.post('/ebermain/mainapi/record/record/list', options)
  },
  count (options) {
    return Request.post('/ebermain/mainapi/record/record/count', options)
  },
  find (pagination, options) {
    if (!pagination.sort) {
      pagination.sort = 'updateTime,state'
    }
    if (!pagination.order) {
      pagination.order = 'DESC,ASC'
    }
    return Request.post('/ebermain/mainapi/record/record/find', Request.paginationBody(options, pagination))
  },
  export (options) {
    options.sort = options.sort || 'updateTime'
    options.order = options.order || 'DESC'
    return Request.download('/ebermain/mainapi/record/record/export', options)
  }
}
